//initial redux
import { put, call, takeEvery, all } from "redux-saga/effects";
import { seriesColor, unitsservice } from "../../../utils";
import moment from "moment-timezone";

const initialState = {};

/////////
//types
export const types = {
	LOAD_DATA: "components/reportChart/LOAD_DATA"
};

///////////
//reducers
export const reducers = {
	reducer(state = initialState, action) {
		switch (action.type) {
			case types.LOAD_DATA: {
				return state;
			}
			default:
				return state;
		}
	}
};
function configYAxis(units) {
	let newYAxis = {
		title: {
			text: units,
			align: "high",
			rotation: 0,
			margin: 0,
			y: -30,
			offset: 14,
			style: {
				"font-weight": "600",
				"font-size": "15px"
			}
		},
		labels: {
			style: {
				 fontSize: "14px",
				 color: '#999',
			}
	  	}
	};

	if (units === "inSession" ) {
		newYAxis.min = 0;
		newYAxis.max = 1;
		newYAxis.height = "20%";
		newYAxis.top = "80%";
	}

	return newYAxis;
}
//returns teh index of the y index with teh specified units.
//if it doesn't exist it creates a new axis with teh units and returns the index for that axis.
function getAxisIndex(chart, units) {
	if (!chart.options) {
		return;
	}
	let axisIndex = 0;
	let symbol = unitsservice.stringToSymbol(units);
	units = symbol ? symbol : units;
	//if the first yaxis doesnt have a value set then
	if (!chart.yAxis[0].userOptions.title) {
		chart.yAxis[0].update(configYAxis(units));
	} else {
		//search for existing with same units and use that, else add a new axis.
		let axisFound = false;
		for (var ii = 0; ii < chart.yAxis.length; ii++) {
			let wkAxis = chart.yAxis[ii];
			if (wkAxis.userOptions.title.text == units) {
				axisFound = true;
				axisIndex = ii;
				break;
			}
		}
		if (!axisFound) {
			axisIndex = chart.yAxis.length;
			chart.addAxis(configYAxis(units));
		}
	}
	return axisIndex;
}

function addDataToChart(chart, data) {
	if (!chart.options) {
		return;
	}

	while(chart.series.length > 0) {
		chart.series[0].remove(true);
	}

	let maxNumOfPoints = 0;
	let title = "";
	for(let ii = 0; ii < data.length; ii++) {
		if(data[ii].values && data[ii].values.length) {
			let runTimeSeries = {
				type: "line",
				data: data[ii].values.map(d => {
					return {x: moment(d.x).valueOf(), y: d.y, timestamp: d.timestamp, units: d.units}
				}),
				yAxis: getAxisIndex(chart, (data[ii].values[0] && data[ii].values[0].units) ? data[ii].values[0].units : ""),
				name: data[ii].description,
				pointPadding: 0,
				groupPadding: 0,
				label: data[ii].description,
				borderWidth: 0,
				turboThreshold: 0,
			};
			title = data[ii].description;
			chart.addSeries(runTimeSeries);
		} else {
			for(let jj = 0; jj < data[ii].length; jj++) {
				let currentNumOfPoints = 0;
				let runTimeSeries = {
					type: "line",
					data: [],
					yAxis: getAxisIndex(chart, (data[ii][jj].values[0] && data[ii][jj].values[0].units) ? data[ii][jj].values[0].units : ""),
					name: moment(data[ii][jj].fromDate).format("DD MMM") + " - " + moment(data[ii][jj].toDate).format("DD MMM") + " (" + moment(data[ii][jj].fromDate).format("YYYY") + ")",
					pointPadding: 0,
					groupPadding: 0,
					label: moment(data[ii][jj].fromDate).format("DD MMM") + " - " + moment(data[ii][jj].toDate).format("DD MMM") + " (" + moment(data[ii][jj].fromDate).format("YYYY") + ")",
					borderWidth: 0,
					turboThreshold: 0,
				};

				data[ii][jj].values.forEach((d, index) => {
					runTimeSeries.data.push({x: index, y: d.y, timestamp: d.timestamp, units: d.units});
					currentNumOfPoints++;
				});

				if(currentNumOfPoints > maxNumOfPoints) {
					maxNumOfPoints = currentNumOfPoints;
				}

				title = data[ii][jj].description;

				chart.addSeries(runTimeSeries);
				chart.xAxis[0].setExtremes(0, maxNumOfPoints);
			}
		}
	}

	chart.update({
		title: {
			text: title
		}
	});

	if(chart) {
		chart.reflow();
		chart.redraw();
	}
}

//////////
//sagas
export const sagas = {
	*rootSaga() {
		yield all([this.loadData()]);
	},

	*loadData() {
		yield takeEvery(types.LOAD_DATA, function({ payload }) {
			const data = payload.data;
			const chart = payload.chart;

			addDataToChart(chart, data);
		});
	}
};

////////
//actions
export const actions = {
	loadData(data, chart) {
		return {
			type: types.LOAD_DATA,
			payload: { data, chart }
		};
	}
};



// WEBPACK FOOTER //
// ./src/components/EvidenceComponents/ReportChart/redux.js